<template>
    <div class="p-3 d-flex flex-column" style="overflow: hidden">

        <assets-filter-component />

        <div
            class="scroll flex-grow-1"
            ref="equipmentsList"
        >
            <div
                class="task"
                v-for="equipment in filteredEquipments.data"
                :key="equipment.id"
                :draggable="true"
                @dragstart="dragStart($event, equipment.id)"
            >
                <div
                    class="py-2 task__title"
                    :style="equipmentStyle(equipment)"
                >
                    <p class="m-0 font-weight-bold">
                        {{ equipment.title }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AssetsFilterComponent from "./filter/AssetsFilterComponent";
import {emitter} from "../../../plugins/Mitt";
import {mapState} from "vuex";

export default {
    components: {
        AssetsFilterComponent,
    },
    data(){
        return {
            canLoadMore: true,
            filteredEquipments: {
                total: 0,
                per_page: 100,
                from: 1,
                to: 0,
                current_page: 1,
                data: [],
            },
        }
    },
    computed: {
        ...mapState('planningFilter', [
            'filter',
            'sort',
        ]),
    },
    methods:{
        getEquipmentsList() {
            if ( (this.loading && this.filteredEquipments.current_page === 1) || !this.canLoadMore ) return;
            this.loading = true;
            const url = route('equipments.list');

            const allowedFilters = ['name', 'free', 'department_ids', 'team_ids'];
            const filter = Object.fromEntries(
                Object.entries(this.filter)
                    .filter(([key]) => allowedFilters.includes(key))
            );

            const params = {
                page: this.filteredEquipments.current_page,
                filter: filter,
                sort: this.sort,
            };
            axios
                .get(url, {
                    params,
                })
                .then((response) => {
                    const newEquipmentData = response?.data?.equipments;
                    if (!newEquipmentData || !Array.isArray(newEquipmentData.data)) {
                        this.canLoadMore = false; // Stop loading if structure is wrong
                        if (this.filteredEquipments.current_page === 1) this.filteredEquipments.data = [];
                        return;
                    }

                    const newItemsCount = newEquipmentData.data.length;

                    if (newEquipmentData.current_page > 1) {
                        this.filteredEquipments.data = this.filteredEquipments.data.concat(
                            newEquipmentData.data,
                        );
                    } else {
                        // Replace data, but merge other pagination properties
                        this.filteredEquipments = newEquipmentData;
                    }

                    this.filteredEquipments.current_page = newEquipmentData.current_page;

                    this.canLoadMore = newItemsCount === this.filteredEquipments.per_page && newItemsCount > 0;
                })
                .catch(error => { // *** ADD/ENSURE CATCH BLOCK ***
                    this.canLoadMore = false; // Stop loading on error
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleScroll() {
            const listElm = this.$refs.equipmentsList;

            if (!listElm || this.loading || !this.canLoadMore) return;

            const currentScroll = listElm.scrollTop;
            const clientHeight = listElm.clientHeight;
            const scrollHeight = listElm.scrollHeight;
            const buffer = 100; // Your buffer
            const triggerPoint = scrollHeight - buffer;
            const currentPosition = currentScroll + clientHeight;

            if (currentPosition >= triggerPoint) {
                // Log when the condition is met *before* fetching

                this.filteredEquipments.current_page += 1;
                this.getEquipmentsList();
            }
        },
        equipmentsListControlPanelScroller() {
            this.$nextTick(() => {
                const listElm = this.$refs.equipmentsList;

                if (listElm && !this.scrollListenerAttached) {
                    listElm.addEventListener('scroll', this.handleScroll);
                    this.scrollListenerAttached = true;
                } else if (listElm && this.scrollListenerAttached) {
                }
            });
        },
        removeScrollListener() {
            const listElm = this.$refs.equipmentsList;
            if (listElm && this.scrollListenerAttached) {
                listElm.removeEventListener('scroll', this.handleScroll);
                this.scrollListenerAttached = false;
            }
        },
        equipmentStyle: function (equipment) {

            return {
                'background-color': equipment.status.color,
                'color': equipment.status.text_color,
            }
        },
        dragStart(event, equipmentId) {
            this.$store.commit('planning/resetDragStartInfo');
            event.dataTransfer.setData('equipmentId', equipmentId);
        },
    },
    mounted(){
        this.getEquipmentsList();
        this.equipmentsListControlPanelScroller();

        emitter.on('planning-slots-changed', () => {
            console.log('planning-slots-changed');
            this.filteredEquipments.current_page = 1;
            this.canLoadMore = true;
            this.getEquipmentsList();
        });
        emitter.on('planning-drop-handled', () => {
            console.log('planning-drop-handled');
            this.filteredEquipments.current_page = 1;
            this.canLoadMore = true;
            this.getEquipmentsList();
        });
        emitter.on('slot-deleted', () => {
            console.log('slot-deleted');
            this.filteredEquipments.current_page = 1;
            this.canLoadMore = true;
            this.getEquipmentsList();
        });
    },
    watch: {
        filter: {
            handler() {
                this.canLoadMore = true;
                this.filteredEquipments.current_page = 1;
                this.filteredEquipments.data = [];

                this.getEquipmentsList();
            },
            deep: true,
        },
        sort: {
            handler() {
                this.canLoadMore = true;
                this.filteredEquipments.current_page = 1;
                this.filteredEquipments.data = [];

                this.getEquipmentsList();
            },
            deep: true,
        },
    }
}
</script>

<style>
.scroll {
    overflow-y: auto;
    overflow-x: hidden;
}
</style>